<div>
  <app-nav-bar>
    <main class="container-main">
      <div class="row d-flex justify-content-between row-header-send">
        <ng-container *ngIf="rType == '0' && statusQueryParam !== 'pendencia'">
          <div class="d-flex gap-8">
            <span class="screen-title">Gestão de ordens de recebimento</span>
          </div>
        </ng-container>
        <ng-container *ngIf="rType == '0' && statusQueryParam === 'pendencia'">
          <div class="d-flex gap-8">
            <span class="screen-title">Gestão de ordens com pendência</span>
          </div>
        </ng-container>
        <ng-container *ngIf="rType == '1' && statusQueryParam !== 'pendencia'">
          <div class="d-flex gap-8">
            <span class="screen-title">Gestão de ordens de envio</span>
          </div>
        </ng-container>
        <ng-container *ngIf="rType == '1' && statusQueryParam === 'pendencia'">
          <div class="d-flex gap-8">
            <span class="screen-title">Gestão de ordens com pendência</span>
          </div>
        </ng-container>
 
        <div>
          <!--  <span (click)="goToOrdersHistory()" class="view-orders tappable"
            >Visualizar todas as ordens</span
          > -->

          <button
            *ngIf="rType == '0'"
            type="button"
            class="btn-footer btn btn-dark-primary-blue"
            (click)="openCreateInboundOrderModal()"
            type="button"
          >
            Criar ordem
          </button>
        </div>
      </div>
      <ng-container *ngIf="rType == '0' && !hideTabs">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          animationDuration="0ms"
          (selectedTabChange)="changeTabStatus($event)"
        >
          <mat-tab label="Aguardando pagamento"></mat-tab>
          <mat-tab label="Pendente análise"> </mat-tab>
          <mat-tab label="Aguardando cotação"></mat-tab>
          <mat-tab label="Prontas para liquidação"></mat-tab>
        </mat-tab-group>
      </ng-container>

      <ng-container *ngIf="rType == '1' && !hideTabs">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          animationDuration="0ms"
          (selectedTabChange)="changeTabStatus($event)"
        >
          <mat-tab label="Pendente análise"></mat-tab>
          <mat-tab label="Ordens cotadas"></mat-tab>
          <mat-tab label="Boletagem"></mat-tab>
          <mat-tab label="Efetivação"></mat-tab>
          <mat-tab label="Confirmação"></mat-tab>
          <mat-tab label="Liquidação"></mat-tab>
        </mat-tab-group>
      </ng-container>

      <div class="card-filters">
        <div class="header-filter">
          <h5>Filtros</h5>
        </div>

        <form [formGroup]="filterForm" (ngSubmit)="onFilter()">
          <div class="content-filter">
            <div class="row">
              <div
                class="col-3"
                *ngIf="isFilterVisible('pendencyType')"
              >
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Tipo de pendência</mat-label>
                  <mat-select
                    formControlName="pendencyType"
                    (selectionChange)="onPendencyTypeChange($event)"
                  >
                    <mat-option
                      *ngFor="let option of pendencyTypeOptions"
                      [value]="option.value"
                    >
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('id')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nº da Ordem</mat-label>
                  <input matInput type="text" name="id" formControlName="id" />
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('agency')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Agência</mat-label>
                  <mat-select formControlName="agency" #agencySelect>
                    <mat-option disabled class="search-option">
                      <ngx-mat-select-search
                        placeholderLabel="Pesquisar agência"
                        noEntriesFoundLabel="Nenhum resultado encontrado"
                        [formControl]="agencyFilterCtrl"
                      >
                      </ngx-mat-select-search>
                    </mat-option>

                    <mat-option value="">Todas</mat-option>

                    <mat-option
                      *ngFor="let ag of filteredAgencies | async"
                      [value]="ag.agencyNumber"
                    >
                      Ag {{ ag.agencyNumber }} - {{ ag.companyName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('createdDate')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Data de criação</mat-label>
                  <input
                    matInput
                    [matDatepicker]="createdDatePicker"
                    formControlName="createdDate"
                  />
                  <mat-datepicker-toggle
                    matPrefix
                    [for]="createdDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #createdDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('sendOption')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Opção de envio</mat-label>
                  <mat-select formControlName="sendOption">
                    <mat-option [value]="null">Todas as opções</mat-option>
                    <mat-option
                      *ngFor="let option of sendOptions"
                      [value]="option.value"
                    >
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('currency')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Moeda</mat-label>
                  <mat-select formControlName="currency">
                    <mat-option [value]="null">Todas as moedas</mat-option>
                    <mat-option *ngFor="let moeda of moedas" [value]="moeda">
                      <img [src]="moeda.image" width="15px" height="15px" />
                      <span class="ml-2">{{ moeda.description }}</span>
                    </mat-option>
                    <mat-select-trigger>
                      <span class="d-flex align-items-center">
                        <ng-container
                          *ngIf="filterFormControls.currency.value; else noIcon"
                        >
                          <mat-icon
                            [svgIcon]="filterFormControls.currency.value?.icon"
                            class="mr-2"
                          ></mat-icon>
                        </ng-container>
                        <ng-template #noIcon></ng-template>
                        <span>
                          {{
                            filterFormControls.currency.value?.description ||
                              "Todas as moedas"
                          }}
                        </span>
                      </span>
                    </mat-select-trigger>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                class="col-3"
                *ngIf="isFilterVisible('bankCurrencyTreasury')"
              >
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Origem da moeda</mat-label>
                  <mat-select formControlName="bankCurrencyTreasury">
                    <mat-option [value]="''">Todas</mat-option>
                    <mat-option
                      *ngFor="let bank of demeBanks$ | async"
                      [value]="bank"
                    >
                      {{ bank }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('value')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Valor</mat-label>
                  <input
                    matInput
                    formControlName="value"
                    type="text"
                    currencyMask
                    [options]="{
                      prefix: currency + ' ',
                      thousands: '.',
                      decimal: ','
                    }"
                  />
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('spread')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Spread</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="spread"
                    currencyMask
                    [options]="{
                      prefix: '',
                      thousands: '.',
                      decimal: ',',
                      precision: 4,
                      suffix: ''
                    }"
                  />
                </mat-form-field>
              </div>

              <div
                class="col-3"
                *ngIf="isFilterVisible('levelingRateTreasury')"
              >
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nivela</mat-label>
                  <input
                    matInput
                    formControlName="levelingRateTreasury"
                    type="text"
                    currencyMask
                    [options]="{
                      prefix: 'R$ ',
                      thousands: '.',
                      decimal: ',',
                      precision: 8
                    }"
                  />
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('settlementFlow')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Fluxo de liquidação</mat-label>
                  <mat-select formControlName="settlementFlow">
                    <mat-option [value]="null">Todos os fluxos</mat-option>
                    <mat-option
                      *ngFor="let flowOption of flowOptions"
                      [value]="flowOption.value"
                    >
                      {{ flowOption.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-3" *ngIf="isFilterVisible('confirmationTreasury')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="confirmationTreasury">
                    <mat-option
                      *ngFor="let option of confirmationTreasuryOptions"
                      [value]="option.value"
                    >
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-3" *ngIf="isFilterVisible('document')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Tipo de Pessoa</mat-label>
                  <mat-select formControlName="personType">
                    <mat-option value="Pj">PJ - Pessoa Jurídica</mat-option>
                    <mat-option value="Pf">PF - Pessoa Física</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                class="col-3"
                *ngIf="isFilterVisible('document') && filterForm.get('personType')?.value === 'Pj'"
              >
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>CNPJ do cliente</mat-label>
                  <input
                    matInput
                    formControlName="document"
                    type="text"
                    name="document"
                    mask="AA.AAA.AAA/AAAA-00"
                    [clearIfNotMatch]="false"
                    uppercase
                    autocomplete="off"
                    style="text-transform: uppercase"
                  />
                </mat-form-field>
              </div>

              <div
                class="col-3"
                *ngIf="isFilterVisible('document') && filterForm.get('personType')?.value === 'Pf'"
              >
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>CPF do cliente</mat-label>
                  <input
                    matInput
                    formControlName="document"
                    type="text"
                    name="document"
                    mask="000.000.000-00"
                    [clearIfNotMatch]="false"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="isFilterVisible('name')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nome/Razão social do cliente</mat-label>
                  <input
                    matInput
                    type="text"
                    name="name"
                    formControlName="name"
                  />
                </mat-form-field>
              </div>

              <div class="col-3" *ngIf="isFilterVisible('slipCode')">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nº do boleto</mat-label>
                  <input matInput type="text" formControlName="slipCode" />
                </mat-form-field>
              </div>
            </div>

            <div class="buttons-filter">
              <button
                type="button"
                [style.width]="'134px'"
                class="btn-outline-dark btn"
                (click)="onClearFilters()"
              >
                Limpar
              </button>

              <button
                [style.width]="'auto'"
                class="btn btn-dark-primary-blue"
                type="submit"
              >
                Aplicar Filtros
              </button>
            </div>
          </div>
        </form>
      </div>

      <ng-container *ngIf="haveOrders">
        <div class="box-order">
          <div class="padding-bottom-32 padding-top-10 header-box">
            <span class="mb-0">
              {{ tableTitle }}
            </span>
            <div class="search-actions-container">
              <button
                *ngIf="
                  currentTab === 'Confirmação' &&
                  tableOrdersAdmin?.selection?.selected?.length > 1
                "
                type="button"
                class="btn-mass-payment"
                (click)="openMassPaymentConfirm()"
              >
                <img
                  src="assets/image/checklist-coins.svg"
                  alt="icon"
                  class="btn-icon"
                />
                Confirmar pagamento em massa
              </button>
              <div class="search-container">
                <input
                  type="text"
                  class="search-input"
                  [formControl]="searchControl"
                  placeholder="Pesquisar pelo nº da ordem, cliente, cnpj... "
                  (keyup.enter)="onFilter()"
                />
                <img
                  src="assets/image/search.svg"
                  class="search-icon"
                  (click)="onFilter()"
                />
              </div>
            </div>
          </div>

          <div
            class="selection-bar"
            *ngIf="tableOrdersAdmin?.selection?.selected?.length > 1"
          >
            <div class="selection-bar-content">
              <span class="selection-text">
                {{
                  "Todas as " +
                    tableOrdersAdmin.selection.selected.length +
                    " ordens nesta página estão selecionadas"
                }}
              </span>
              <button
                class="btn-clear-selection"
                (click)="tableOrdersAdmin.selection.clear()"
              >
                Limpar seleção
              </button>
            </div>
          </div>

          <div class="padding-content">
            <ng-container *ngIf="!isMobile">
              <app-table-orders-admin
                *ngIf="showTables"
                [displayedColumns]="tableDisplayedColumns"
                [data]="orders"
                [pageNumber]="pageNumber"
                [pageSize]="pageSize"
                [totalElements]="totalElements"
                [currentTab]="currentTab"
                (pageChange)="updatePageData($event)"
              ></app-table-orders-admin>
            </ng-container>

            <ng-container *ngIf="isMobile">
              <app-table-orders-admin
                *ngIf="showTables"
                [displayedColumns]="tableDisplayedColumns"
                [data]="orders"
                [pageNumber]="pageNumber"
                [pageSize]="pageSize"
                [totalElements]="totalElements"
                [currentTab]="currentTab"
                (pageChange)="updatePageData($event)"
              ></app-table-orders-admin>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="loading"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <span class="spinner-border text-primary"></span>
        </div>
      </div>

      <div
        *ngIf="!haveOrders && !showOrderError && !loading"
        class="accordion-item painel painel-accordion no-orders"
      >
        <div class="img-no-orders">
          <img width="240" height="160" src="assets/image/no-order-icon.svg" />
        </div>

        <p *ngIf="rType == '0'" id="txt-create-order">
          Não há ordens de recebimento.
        </p>
        <p *ngIf="rType == '1'" id="txt-create-order">
          Não há ordens de envio.
        </p>
      </div>

      <div
        *ngIf="showOrderError"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <img
            width="258"
            height="160"
            src="assets/image/error-order-icon.svg"
          />
        </div>

        <p id="txt-error-orders-register">Infelizmente encontramos um erro!</p>
        <p id="txt-error-order">
          Você pode aguardar uns instantes e tentar recarregar a <br />página
          mais uma vez.
        </p>

        <div class="btn-send-content">
          <button
            (click)="reloadPage()"
            class="btn btn-block mt-0 ml-3 btn-dark-primary-blue"
            type="button"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    </main>
  </app-nav-bar>
</div>
